module.exports = __webpack_public_path__ + "static/img/guojimajiang.78c3f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/guojimajiang.jpg
// module id = h+oE
// module chunks = 0